import React, { useState } from "react";
import api from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";

const ReceivePOForm: React.FC<{ po: any }> = ({ po }) => {
  const [received, setReceived] = useState(false);
  const { token } = useAuth();

  const handleReceive = async () => {
    try {
      await api.post(`/inventory/po/${po._id}/receive`, null, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setReceived(true);
      alert("PO marked as received!");
    } catch (e: any) {
      alert(e?.response?.data?.message || "Failed to mark as received");
    }
  };

  if (po.status === "received" || received) return null;

  return (
    <div className="my-4">
      <button
        className="bg-green-600 text-white px-5 py-2 rounded"
        onClick={handleReceive}
      >
        Mark as Received
      </button>
    </div>
  );
};
export default ReceivePOForm;
